import { create } from "zustand";
import { useFetchMonthlyExpenseReportSlice } from "../slices/ExpenseDashBoardSlices/fetchMonthlyExpenseReportSlice";
import { useAddCommentAmountExpenseReportSlice } from "../slices/ExpenseDashBoardSlices/addCommentAmountExpenseReportSlice";
import { useFetchManagerExpenseApprovalSlice } from "../slices/ExpenseDashBoardSlices/fetchManagerExpenseApproval";
import { useAddManagerCommentAmountExpenseStateSlice } from "../slices/ExpenseDashBoardSlices/addManagerCommentAmountExpenseSlice";
import { useFetchAddExpenseReasonSlice } from "../slices/ExpenseDashBoardSlices/fetchAddExpenseReasonSlice";
import { useAddUploadFileExpenseSlice } from "../slices/ExpenseDashBoardSlices/addUploadFileExpenseSlice";
import { useAddReadFileExpenseSlice } from "../slices/ExpenseDashBoardSlices/addReadFileExpenseSlice";
import { useDeleteUploadReadFileExpenseSlice } from "../slices/ExpenseDashBoardSlices/deleteUploadReadFileExpenseSlice";

interface ExpenseDashBoardInterface
  extends ReturnType<typeof useFetchMonthlyExpenseReportSlice>,
  ReturnType<typeof useAddCommentAmountExpenseReportSlice>,
  ReturnType<typeof useFetchManagerExpenseApprovalSlice>,
  ReturnType <typeof useAddManagerCommentAmountExpenseStateSlice>,
  ReturnType <typeof useFetchAddExpenseReasonSlice>,
  ReturnType <typeof useAddUploadFileExpenseSlice>,
  ReturnType <typeof useAddReadFileExpenseSlice>,
  ReturnType <typeof useDeleteUploadReadFileExpenseSlice> {}

export const ExpenseDashBoardStore = create<ExpenseDashBoardInterface>((...a) => ({
  ...useFetchMonthlyExpenseReportSlice(...a),
  ...useAddCommentAmountExpenseReportSlice(...a),
  ...useFetchManagerExpenseApprovalSlice(...a),
  ...useAddManagerCommentAmountExpenseStateSlice(...a),
  ...useFetchAddExpenseReasonSlice(...a),
  ...useAddUploadFileExpenseSlice(...a),
  ...useAddReadFileExpenseSlice(...a),
  ...useDeleteUploadReadFileExpenseSlice(...a),
}));